import React, { useState, Fragment } from 'react';
import styles from './wealtiest-cities.module.scss';
import { dataConvertOverview } from '../../utils/overall-convert';
import { wealthiestOverview } from '../../data/data-wealthiest-cities';
import { totalWorldData } from '../../data/data-wealthiest-cities';
import { formatNumberWithDot } from '../../utils/utils';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';

const options = [
  { label: "Millionaires (USD 1m+)", value: "millionaires" },
  { label: "Centi-millionaires (USD 100m+)", value: "centiMillionaires" },
  { label: "Billionaires (USD 1bn+)", value: "billionaires" },
  { label: "Millionaire growth % 2013 to 2023", value: "centiGrowth" },
];

const WealtiestCities = () => {

  const [sortColumn, setSortColumn] = useState("millionaires");
  const [onClickColumn, setOnClickColumn] = useState("millionaires");

  const [cityCount, setCityCount] = useState(1);
  const [milCount, setMilCount] = useState(1);
  const [centiMilCount, setCentiMilCount] = useState(1);
  const [bilCount, setBilCount] = useState(1);
  const [centiGrowthCount, setCentiGrowthCount] = useState(1);


  const dataOverview = () => {
    return dataConvertOverview(wealthiestOverview);
  }

  const handleOptionSelect = (option) => {
    setSortColumn(option.value);
    setOnClickColumn(option.value);
  };

  const handleSort = (columnName) => {
    switch (columnName) {
      case 'city':
        (cityCount === 1) ? setCityCount(-1) : setCityCount(1);
        break;
      case 'millionaires':
        (milCount === 1) ? setMilCount(-1) : setMilCount(1);
        break;
      case 'centiMillionaires':
        (centiMilCount === 1) ? setCentiMilCount(-1) : setCentiMilCount(1);
        break;
      case 'billionaires':
        (bilCount === 1) ? setBilCount(-1) : setBilCount(1);
        break;
      case 'centiGrowth':
        (centiGrowthCount === 1) ? setCentiGrowthCount(-1) : setCentiGrowthCount(1);
        break;
      default:
        break;
    }
  
    if (columnName !== 'city') {
      setSortColumn(columnName) 
    }
    setOnClickColumn(columnName);
    
  };

  const reverseSortNum = (columnName, count) => {
    if (count === 1) {
      return dataOverview().sort((a, b) => b[columnName] - a[columnName]);
    }
    return dataOverview().sort((a, b) => a[columnName] - b[columnName]);
  }

  const handleSortingOptions = (columnName) => {
    switch (columnName) {
      case 'city':
        return (cityCount === 1) ?
          dataOverview().sort((a, b) => b[columnName].localeCompare(a[columnName]))
          : dataOverview().sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'millionaires':
        return reverseSortNum(columnName, milCount);
      case 'centiMillionaires':
        return reverseSortNum(columnName, centiMilCount);
      case 'billionaires':
        return reverseSortNum(columnName, bilCount);
      case 'centiGrowth':
        return reverseSortNum(columnName, centiGrowthCount);
      default:
        break;
    }
  }

  const getMax = (arr, field) => {
    let max;
    for (var i=0 ; i<arr.length ; i++) {
        if (max == null || parseInt(arr[i][field]) > parseInt(max[field]))
            max = arr[i];
    }
    return max;
  }
  
  const sortedData = onClickColumn
    ? handleSortingOptions(onClickColumn)
    : dataOverview();
  
  
  const maxField = (sortedData) ? getMax(sortedData, "centiGrowth") : 0;
  
  
  return (
    <>
      <h3 className="mb-5">America's Wealthiest Cities</h3>
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`} >
        <thead>
          <tr>
            <th className={`text-left 
                            ${styles.cityColumn} 
                            ${styles.sortableColumn} 
                            ${onClickColumn === 'city' ? styles.selectedColumn : ''}
                            `}
                onClick={() => handleSort("city")}
                style={{paddingLeft: 0}}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Cities</span>
                {(cityCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            {/* <th
              className={`text-left ${styles.cellHideMobile} ${styles.countryColumn} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(cityCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th> */}
           <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${onClickColumn === 'millionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'millionaires' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("millionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Millionaires<br />(USD 1m+)</span>
                {(milCount === 1) ? <IconSort /> : <ReverseIconSort />}

              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${onClickColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'centiMillionaires' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("centiMillionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Centi-millionaires<br />(USD 100m+)</span>
                {(centiMilCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${onClickColumn === 'billionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'billionaires' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("billionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Billionaires<br />(USD 1bn+)</span>
                {(bilCount === 1) ? <IconSort /> : <ReverseIconSort />}

              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${onClickColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                              ${sortColumn === 'centiGrowth' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("centiGrowth")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Millionaire growth %<br/>2013 to 2023</span>
                {(centiGrowthCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>

            {/* <th className={`text-right ${styles.cellHideMobile}`}>Investment <br/>migration options</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow}`}>
                {/* <tr onClick={() => handleMobileRowClick(index)} className={`${styles.contentRow} ${index === display ? styles.openedRow : ''}`}> */}
                {/* <td>{item.city}</td> */}
                <td className={`text-left 
                                ${styles.cityColumn}
                                ${styles.sortableColumn} 
                                ${onClickColumn === 'city' ? styles.selectedColumn : ''}
                              `}>
                  {item.city}
                </td>
                {/* <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td> */}

                <td className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn === onClickColumn  ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                          `}>
                  {sortColumn === "centiGrowth" ?
                    <ProgressBar
                      percentValue={item.centiGrowth > 0 ? item.centiGrowth * 100 / maxField.centiGrowth : 0}
                      labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                    />
                    : formatNumberWithDot(item[sortColumn])
                  }
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${onClickColumn === 'millionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.millionaires)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${onClickColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.centiMillionaires)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${onClickColumn === 'billionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.billionaires)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                ${onClickColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                              `}>
                  <ProgressBar
                    percentValue={item.centiGrowth > 0 ? item.centiGrowth * 100 / maxField.centiGrowth : 0}
                    labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                  />
                </td>

              </tr>

            </Fragment>
          ))}


        </tbody>
      </table>


      <table className={`chartTable ${styles.overviewChartTable}`}>
        <tbody>
          
          <tr style={{height: "40px"}}></tr>

          {totalWorldData.map((item) => (
            <Fragment key='data-world-total' >
              <tr className={`${styles.contentRow}`} >
                {/* <tr onClick={() => handleMobileRowClick(index)} className={`${styles.contentRow} ${index === display ? styles.openedRow : ''}`}> */}
                <td
                  className={`${styles.cityColumn} ${onClickColumn === 'city' ? styles.selectedColumn : ''}`}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                ><b>{item.city}</b></td>
                
                <td rowSpan={2} className={`text-right
                                              ${styles.hiddenTableRow}
                                              ${styles.sortableColumn}
                                              ${styles.combinateRowCells}
                                              ${styles.progressBarColumn}
                                              ${sortColumn === onClickColumn ? styles.selectedColumn : ''}
                                              ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                            `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  <b>
                    {sortColumn === "centiGrowth" ?
                      <ProgressBar
                        percentValue={item.centiGrowth > 0 ? item.centiGrowth * 100 / maxField.centiGrowth : 0}
                        labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                      />
                      : formatNumberWithDot(item[sortColumn])
                    }
                  </b>
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${onClickColumn === 'millionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  <b>{formatNumberWithDot(item.millionaires)}</b>
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${onClickColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ padding: "15px 30px", borderTop: "1px solid #C1C5C8" }}
                >
                  <b>{formatNumberWithDot(item.centiMillionaires)}</b>
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${onClickColumn === 'billionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  <b>{formatNumberWithDot(item.billionaires)}</b>
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.progressBarColumn}
                                  ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                  ${onClickColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  <b>
                    <ProgressBar
                      percentValue={item.centiGrowth > 0 ? item.centiGrowth * 100 / maxField.centiGrowth : 0}
                      labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                    />
                  </b>
                </td>
              </tr>
            </Fragment>
          ))}
          <tr></tr>

        </tbody>
      </table>

      <div className="footer-note mt-5">
        <ul>
          <li>Figures for December 2023.</li>
          <li>Only includes cities with over 25,000 resident millionaires.</li>
          <li>Millionaire figures rounded to nearest 100.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div>
    </>
  )
}

export default WealtiestCities;